<edu-card class="settings-card">
  <h2 edu-card-title>Supervisor number cards</h2>
  <p class="desc">
    When enabled, students see their supervisor's photo and phone number on their home page.
    When disabled, this card is hidden from all students in this organization.
  </p>

  <div class="toggle-row">
    <div class="toggle-label">
      <span class="toggle-title">Show supervisor number cards to students</span>
      <span class="toggle-hint" *ngIf="!canManage">You do not have permission to change this setting.</span>
    </div>

    <button
      type="button"
      class="switch"
      role="switch"
      [class.on]="enabled()"
      [attr.aria-checked]="enabled()"
      [disabled]="!canManage || isSaving()"
      (click)="toggle()"
    >
      <span class="knob"></span>
    </button>
  </div>
</edu-card>
